import Vue from "vue";

import TransactionLogTickets from "./TransactionLogTickets.vue";

export function load() {
    const selector = "transaction-log-tickets";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(TransactionLogTickets, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
